<template>
  <div>
    <div class="my-5 container card_container">
      <modal-cambia-data-disp @getData="getData"></modal-cambia-data-disp>
      <b-card bg-variant="light">
        <b-container class="bv-example-row pt-lg-6">
          <b-row>
            <b-col sm class="mb-7">
              <span class="text-primary">Codice fiscale</span><br />
              <span>{{ assistito.codiceFiscale }}</span>
            </b-col>
            <b-col sm class="mb-7">
              <span class="text-primary">Assistito</span><br />
              <span>{{ assistito.nome }} {{ assistito.cognome }}</span>
            </b-col>
            <b-col sm class="mb-7">
              <span class="text-primary">Data di nascita</span><br />
              <span>{{ assistito.dataNascita }}</span>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
      <div class="separator border-4 my-3"></div>

      <h3 class="mb-5 titolo"><i class="fas fa-clipboard-list"></i> Proposta (Prima disponibilità)</h3>

      <datatable-disponibilita-alpi :prestazioneScelta="prestazioneScelta"></datatable-disponibilita-alpi>

      <b-container class="bv-example-row">
        <b-row>
          <b-col
            ><a href="/prenota">
              <b-button variant="my-5 btn-outline" class="mb-5" @click="onIndietro"><i class="fas fa-angle-double-left"></i> Indietro </b-button>
            </a></b-col
          >
          <b-col>
            <b-button v-b-modal.modal-5 class="btn-outline"><i class="fas fa-calendar-plus"></i> Cambia data proposta </b-button>
          </b-col>
          <b-col>
            <b-button variant="my-5 btn-outline" class="mb-5 ml-21" @click="onConfermaPrenotazione"><i class="fas fa-clipboard-check"></i> Conferma Proposta </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import DatatableDisponibilitaAlpi from "../datatable/datatableDisponibilitaAlpi.vue";
import modalCambiaDataDisp from "../modal/modalCambiaDataDisp.vue";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  props: {
    assistito: Object,
    sedeSelezionata: String,
    strutturaSelezionata: Array,
    prestazioneSelezionata: Object,
  },
  components: {
    DatatableDisponibilitaAlpi,
    modalCambiaDataDisp,
    Loading,
  },
  data() {
    return {
      showModal: false,
      messaggioPrePrenotazione: JSON.parse(sessionStorage.getItem("messaggiUtente")).messaggioPrePrenotazione,
      pathResourceAnnulla: "/api/v2.0/appecupt/aslengi/annullaprenotazionesospesa",
      pathResourceConferma: "/api/v2.0/appecupt/aslengi/alpi/confermaPrenotazione",
      jsonData: {
        prossimiEsamiDisponibili: [],
      },
      token: null,
      tokenLogin: null,
      isLoading: false,
      prestazioneScelta: null,
    };
  },
  mounted: function () {
    let me = this;
    me.jsonData.prossimiEsamiDisponibili = me.esamiDisponibili;

    me.loadData();
  },
  methods: {
    async onConfermaPrenotazione() {
      let me = this;
        let msg = getVocabolario("domandaConfermaPrenotazione")
        if(!msg)
            msg = "Sei sicuro di voler confermare la prenotazione?"
      me.$bvModal
        .msgBoxConfirm(msg, {
          title: "Conferma Prenotazione",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if (response) {
            try {
              const paramentiConferma = {
                codicePrestazione: me.prestazioneSelezionata.codicePrestazione,
                dataAppuntamento: me.prestazioneScelta[0].dataAppuntamento,
                statoAppuntamento: me.prestazioneScelta[0].statoAppuntamento,
                idUnita: me.strutturaSelezionata[0].idUnita,
                descrizioneUnita: me.strutturaSelezionata[0].descrizioneUnita,
                descrizionePrestazione: me.prestazioneSelezionata.descrizionePrestazione,
                idPrestazione: me.prestazioneSelezionata.idPrestazione,
              };
              me.isLoading = true;
              const responseConfermaPrenotazione = await EngiService.confermaPrenotazioneAlpi(paramentiConferma);
              if (responseConfermaPrenotazione.data.stato === 200) {
                me.isLoading = false;
                this.$bvModal
                  .msgBoxOk(responseConfermaPrenotazione.data.data, {
                    title: "Esito Prenotazione",
                    size: "md",
                    okVariant: "outline-success",
                    headerClass: "vv-msg-header-success",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {
                    me.$emit("setStep", 0);
                  })
                  .catch(() => {
                    me.$emit("setStep", 0);
                  });
              } else {
                me.isLoading = false;
                this.$bvModal
                  .msgBoxOk(responseConfermaPrenotazione.data.errore, {
                    title: "Errore",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "vv-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {})
                  .catch((err) => {
                    me.isLoading = false;
                    console.log(err);
                  });
              }
            } catch (e) {
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {
                  me.isLoading = false;
                })
                .catch(() => {
                  me.isLoading = false;
                });
            }
          }
        })
        .catch((e) => {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(e, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
        });
    },
    loadData() {
      let me = this;
      me.token = sessionStorage.getItem("tokenWSO2");
      me.tokenLogin = sessionStorage.getItem("loginData");
      me.loadDisponibilita();
    },
    async loadDisponibilita() {
      let me = this;
      me.isLoading = true;
      try {
        const parametriDisponibilita = {
          idPrestazione: me.prestazioneSelezionata.idPrestazione,
          idUnita: me.strutturaSelezionata[0].idUnita,
        };
        const responseDisponibilita = await EngiService.ricercaDisponibilitaAlpi(parametriDisponibilita);
        if (responseDisponibilita.data.stato === 200) {
          me.prestazioneScelta = responseDisponibilita.data.data;
          me.isLoading = false;
        } else {
          me.isLoading = false;
          this.$bvModal
            .msgBoxOk(responseDisponibilita.data.errore, {
              title: "Errore",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
              me.$emit("setStep1", 1);
            })
            .catch((err) => {
              me.isLoading = false;
              console.log(err);
            });
        }
      } catch (error) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(error, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {
            me.isLoading = false;
          })
          .catch(() => {
            me.isLoading = false;
          });
      }
    },
    onIndietro() {
      let me = this;
      me.$emit("setStep", 1);
    },
    async getData(data) {
      let me = this;
      me.isLoading = true;
      const bodyProssimaDispSede = {
        idPrestazione: me.prestazioneSelezionata.idPrestazione,
        idUnita: me.strutturaSelezionata[0].idUnita,
        dataRicerca: data,
      };
      try {
        const responseProssimaDisp = await EngiService.ricercaDisponibilitaAlpi(bodyProssimaDispSede);
        if (responseProssimaDisp.data.stato === 200) {
          me.prestazioneScelta = responseProssimaDisp.data.data;
          me.isLoading = false;
        } else {
          me.isLoading = false;
          this.$bvModal
            .msgBoxOk(responseProssimaDisp.data.errore, {
              title: "Errore",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch((err) => {
              me.isLoading = false;
              console.log(err);
            });
        }
      } catch (error) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(error, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {
            me.isLoading = false;
          })
          .catch(() => {
            me.isLoading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.center {
  margin: auto;
  width: 60%;
  padding: 10px;
}
</style>
